import { render, staticRenderFns } from "./KnownMethods.vue?vue&type=template&id=2fc27286&"
import script from "./KnownMethods.vue?vue&type=script&lang=js&"
export * from "./KnownMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports